import { FooterDisclaimer } from 'organisms';
import { useNavigate } from 'react-router-dom';
import { NavigateConst } from 'common';
import { useTranslation } from 'react-i18next';
import { Button, Headings, Paragraph } from '@sentara-health/optimahealth_web';
import { useContext } from 'react';
import { GlobalContext } from 'context';
import ProxyHeader from './ProxyHeader';

const ProxyAuthorizationError = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getFeature } = useContext(GlobalContext);

  // Return null if DR feature is not enabled
  if (getFeature && !getFeature.DesignatedRepresentativeTab) {
    return null;
  }

  return (
    <div className="d-flex flex-column h-100">
      <ProxyHeader />
      <div className="container-fluid" aria-live="polite">
        <div id="main-content" className="container-lg px-main">
          <div className="row justify-content-center my-5">
            <div className="col-lg-6 col-md-8 col-sm-12">
              <div className="text-center mb-5" data-testid="proxy-authorization-error">
                <Headings
                  level={2}
                  text={t('common.proxyAuthorizationErrorTitle')}
                  variant="semiBold"
                />
                <Paragraph
                  text={t('common.proxyAuthorizationErrorMessage1')}
                  variant="regular"
                  className="my-3"
                />
                <Paragraph
                  text={t('common.proxyAuthorizationErrorMessage2')}
                  variant="regular"
                  className="my-3"
                />
                <Paragraph
                  text={t('common.proxyAuthorizationErrorMessage3')}
                  variant="regular"
                  className="my-3"
                />
                <div className="pt-5">
                  <Button
                    onClick={() => {
                      navigate(NavigateConst.signIn);
                    }}
                    type="button"
                    dataTestId="redirectLoginPage"
                    variant="primary_btn"
                    className="btn-md-width"
                  >
                    {t('common.returnLogin')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="container-lg mt-auto">
        <FooterDisclaimer />
      </footer>
    </div>
  );
};

export default ProxyAuthorizationError;